import React from 'react';

/**
 * MotifBackground — clean geometric pinwheel/triangle tile.
 * - Wordless (no logo).
 * - Single colour via CSS mask + `currentColor`-style background-color.
 * - Applied on navy SectionBand backgrounds ONLY.
 * - Never behind body text at higher than locked tokens.
 *
 * Surface-specific opacity tokens (do NOT pass raw opacity in app code —
 * use the `surface` prop so the four navy surfaces stay aligned):
 *    surface="hero"    → var(--motif-op-hero)   = 0.07
 *    surface="footer"  → var(--motif-op-footer) = 0.06
 *    surface="honest"  → var(--motif-op-honest) = 0.04
 *    surface="cta"     → var(--motif-op-cta)    = 0.04
 *
 * `opacity` prop is still supported for QC route only.
 */
export const MotifBackground = ({
  surface,
  opacity,
  size = 240,
  color = '#DCF0F5',
  className = '',
  style = {},
}) => {
  const url = "url('/brand/motif-tile.svg')";
  const op = opacity !== undefined
    ? opacity
    : `var(--motif-op-${surface || 'hero'})`;
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        backgroundColor: color,
        WebkitMaskImage: url,
        maskImage: url,
        WebkitMaskRepeat: 'repeat',
        maskRepeat: 'repeat',
        WebkitMaskSize: `${size}px ${size}px`,
        maskSize: `${size}px ${size}px`,
        opacity: op,
        ...style,
      }}
    />
  );
};
